<template>
  <div @click="toggle($event)">
    <teleport to="#RightMenuMobile" v-if="!isVisible">
      <div v-aw-driver-element="'RightMenu'">
        <slot />
      </div>
    </teleport>
    <div v-aw-driver-element="'RightMenu'" v-else>
      <slot />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useWindowSize } from '@vueuse/core'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { mapStores } from 'pinia'

export default {
  setup() {
    const { width, height } = useWindowSize()

    return {
      isVisible: computed(() => {
        return width.value > 992 && height.value > 0
      }),
      toggle(ev) {
        if (ev && ev.target.tagName === 'A' && ev.target.getAttribute('href') === '#') {
          ev.stopPropagation()
        }
      }
    }
  },
  computed: {
    ...mapStores(useBcSelectedStore)
  },
};
</script>

<style lang="scss" scoped></style>
